export default __webpack_public_path__ + "static/media/404.2f6ebf97.svg";